import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/Provider/api/v1',
  timeout: 30000, // 30 seconds
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // List of public endpoints that don't need authentication
    const publicEndpoints = [
      '/SendOtp/',  // Signup OTP
      '/VerifyOtp/',  // Signup OTP verification
      '/ResendOtp/',  // Resend signup OTP
      '/Login/',  // Login
      '/ProviderSendForgotPasswordOTP/',  // Forgot password OTP
      '/ProviderVerifyForgotPasswordOTP/',  // Forgot password OTP verification
    ];

    // Check if current request is to a public endpoint
    const isPublicEndpoint = publicEndpoints.some(endpoint =>
      config.url.includes(endpoint)
    );

    // For FormData, don't set Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }

    // Only add token for non-public endpoints
    if (!isPublicEndpoint) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `token ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // Handle specific error cases
      if (status === 401) {
        // Don't clear token on 401 during login/signup/forgot password
        if (!error.config.url.includes('/Login/') &&
            !error.config.url.includes('/SendOtp/') &&
            !error.config.url.includes('/VerifyOtp/') &&
            !error.config.url.includes('/ProviderSendForgotPasswordOTP/') &&
            !error.config.url.includes('/ProviderVerifyForgotPasswordOTP/')) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('isAuthenticated');
          const basePath = process.env.NODE_ENV === 'production' ? '/provider' : '';
          window.location.href = `${basePath}/signin`;
        }
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
